<template>
  <v-carousel cycle>
    <v-carousel-item
      v-for="(item, i) in items"
      :key="i"
      :src="item.src"
      reverse-transition="reverse-transition"
      transition="slide-x-reverse-transition"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("@/assets/carousel/gyuszigumi1.jpg")
        },
        {
          src: require("@/assets/carousel/gyuszigumi2.jpg")
        },
        {
          src: require("@/assets/carousel/gyuszigumi3.jpg")
        },
        {
          src: require("@/assets/carousel/gyuszigumi4.jpg")
        },
        {
          src: require("@/assets/carousel/gyuszigumi5.jpg")
        },
        {
          src: require("@/assets/carousel/gyuszigumi6.jpg")
        }
      ]
    };
  }
};
</script>
